<template>
  <div class="footer">
    <div class="links">
      <a href="https://www.yyxiaobin.com" target="_blank" title="号码商城"
        >号码商城</a
      >
    </div>
    <div class="copyright">
      Copyright
      <a-icon type="copyright" /> 2019 <span>www.yyxiaobin.com</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "GlobalFooter",
  data() {
    return {};
  }
};
</script>

<style lang="less" src="./index.less" scoped></style>
